import React from "react";
import styled from "styled-components";

const Button=styled.button`
display:flex;
margin: 32px auto;
font-family:-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
font-size:16px;
font-weight:700;
border-radius:6px;
border:none;
height: 54px;
margin-bottom: 0;
padding:1em;
color:white;
outline:none;
background-color: rgb(0, 136, 255);
cursor:pointer;

&:active
{
    background-color: rgb(0, 111, 230) !important;
}`;


const BlueButton=({children,onClick})=>
{
    return <Button onClick={onClick}>{children}</Button>
}

export default BlueButton